import React from "react";
import {buildImpLink} from "data/utils/connextra";
import styled from "@emotion/styled";

const Img = styled.img`
	position: absolute;
	z-index: -10000;
	left: 0;
	top: 0;
	opacity: 0;
	width: 1px;
	height: 1px;
`;
export const CxtImpression: React.FC = () => {
	const link = buildImpLink();

	return <Img src={link} />;
};
